// extracted by mini-css-extract-plugin
module.exports = {"description":"IAMMIAFAQBlock-module--description--2u81k","section":"IAMMIAFAQBlock-module--section--11OkX","title":"IAMMIAFAQBlock-module--title--3FPVG"};